import { Link } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

import { formatCredits as formatCreditsDomain } from "@domain/billing/format-credits";
import type { CreditStatus } from "@/hooks/useCreditBalance";

function formatCredits(balance: string): string {
  return formatCreditsDomain({ credits: balance });
}

interface CreditBalancePillProps {
  balance: string;
  status: CreditStatus;
}

export function CreditBalancePill({ balance, status }: CreditBalancePillProps) {
  if (status === "loading") {
    return (
      <span
        className="flex items-center gap-1.5 rounded-full bg-black/5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-black/40 dark:bg-white/10 dark:text-white/40"
        aria-label="Loading credits"
      >
        <Loader2 className="h-3 w-3 animate-spin" />
        <span aria-hidden>…</span>
      </span>
    );
  }

  if (status === "empty") {
    return (
      <Link
        to="/dashboard"
        className="flex items-center gap-1.5 rounded-full bg-brand-coral/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-brand-coral-dark transition-colors hover:bg-brand-coral/20 dark:bg-brand-coral/20 dark:text-brand-coral dark:hover:bg-brand-coral/30"
      >
        0.00 — Top up
      </Link>
    );
  }

  if (status === "negative") {
    return (
      <Link
        to="/dashboard"
        className="flex items-center gap-1.5 rounded-full bg-brand-coral/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-brand-coral-dark transition-colors hover:bg-brand-coral/20 dark:bg-brand-coral/20 dark:text-brand-coral dark:hover:bg-brand-coral/30"
      >
        {formatCredits(balance)} cr — Top up
      </Link>
    );
  }

  return (
    <span className="flex items-center gap-1.5 rounded-full bg-black/5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-black/70 dark:bg-white/10 dark:text-white/70">
      {formatCredits(balance)} cr
    </span>
  );
}
